import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelRadio as _vModelRadio, withKeys as _withKeys, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "spinner-border spinner-border-lg",
    role: "status",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "row mt-4"
}
const _hoisted_5 = { class: "col-12 mt-2" }
const _hoisted_6 = { class: "border-bottom pb-2 mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "col-12 mt-2 mb-2"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, "Selecione o número origem", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-12 mb-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, "Nome", -1)
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "col-12 mt-2 mb-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, "Mensagem", -1)
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 1,
  class: "col-12 mt-2 border-bottom pb-4"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-12 mb-1" }, "Tipo de Anexo", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  style: {"margin-left":"0.5rem"},
  for: "fileOption"
}, "Arquivo/Imagem", -1)
const _hoisted_19 = { style: {"margin-top":"0.5rem"} }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  style: {"margin-left":"0.5rem"},
  for: "linkOption"
}, "Link de Vídeo", -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-12 mb-1 mt-2",
  for: "arquivo"
}, "Anexar Arquivo", -1)
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-12 mb-1",
  for: "videoUrl"
}, "Inserir Link de Vídeo", -1)
const _hoisted_25 = { class: "col-12 mt-2 mb-2" }
const _hoisted_26 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_27 = ["href"]
const _hoisted_28 = {
  key: 2,
  class: "col-12 mt-2 input-group"
}
const _hoisted_29 = { class: "input-group-append" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "input-group-append" }
const _hoisted_32 = {
  key: 3,
  class: "col-12"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("small", {
  id: "emailHelp",
  class: "form-text text-muted"
}, [
  /*#__PURE__*/_createTextVNode(" O arquivo CSV deve conter as variáveis no cabeçalho. Cada coluna representa uma variável que pode ser usada na mensagem, sendo "),
  /*#__PURE__*/_createElementVNode("b", null, "nome;"),
  /*#__PURE__*/_createElementVNode("b", null, "numero"),
  /*#__PURE__*/_createTextVNode(" obrigatórios. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Veja "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/csv-example.csv",
    download: "csv-example.csv"
  }, "um exemplo de CSV"),
  /*#__PURE__*/_createTextVNode(" para seguir como referência. ")
], -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 4,
  class: "col-12 dests pt-2"
}
const _hoisted_36 = { class: "list-group" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "col-12 mt-4 pt-3 border-top" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-6 mt-2 pt-2 text-md-start" }
const _hoisted_41 = {
  key: 0,
  class: "col-6 mt-2 pt-2 text-md-end"
}
const _hoisted_42 = ["disabled"]
const _hoisted_43 = {
  key: 1,
  class: "btn btn-info",
  disabled: ""
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  key: 1,
  class: "col-6 mt-2 pt-2 text-md-end"
}
const _hoisted_47 = ["disabled"]
const _hoisted_48 = {
  key: 1,
  class: "btn btn-info",
  disabled: ""
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_50 = [
  _hoisted_49
]

import {onMounted, reactive, ref} from "vue";
  import Papa from "papaparse"
  import {MaskaDetail, vMaska} from "maska"
  import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome"
  import {faClock} from "@fortawesome/free-regular-svg-icons"
  import {faCheck, faCheckDouble, faBan, faExclamationTriangle} from "@fortawesome/free-solid-svg-icons"
  import Destination from "@/models/Destination";
  import {MessageStatusEnum} from "@/models/MessageStatusEnum";
  import apiService from "@/services/api.service";
  import transmissionService from "@/services/transmission.service";
  import {useRoute, useRouter} from "vue-router";
  import {AxiosResponse} from "axios";

  interface Contact {
    phone_number: string;
    name: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TransmissionsCreate',
  setup(__props) {


  const uploadExcel = ref<HTMLFormElement | null>(null);

  const dests = ref<Destination[]>([]);
  const contactInput = ref<HTMLInputElement | null>(null);
  const body = ref('');
  const name = ref('');

  const contactValue = reactive({} as MaskaDetail);
  const maskedValue = ref('');

  const isLoading = ref(false);
  const isUploading = ref(false);
  const attach = ref<HTMLInputElement | null>(null);
  const uploadUrl = ref('');
  const uploadFileName = ref('');
  const attachmentType = ref('file');
  const route = useRoute();
  const router = useRouter();
  const id = parseInt(route.params.id as string);
  const cloneId = parseInt(route.params.cloneId as string);
  const pageTitle = ref('Criar Transmissão');
  
  function addContact() {
    if (contactValue.unmasked) {
      dests.value.push({ number: contactValue.unmasked, name: maskedValue.value });
      maskedValue.value = '';
      contactInput.value?.focus();
    }
  }

  function getIconByStatus(status: MessageStatusEnum) {
    // console.log(status);
    switch (status) {
      case MessageStatusEnum.PENDING:
        return faClock;
      case MessageStatusEnum.FAIL:
        return faExclamationTriangle;
      case MessageStatusEnum.SENT:
        return faCheck;
      case MessageStatusEnum.DELIVERED:
      case MessageStatusEnum.READ:
        return faCheckDouble;
    }
  }

  function getNumberOnly(value: string) {
    return value.replace(/\D/g, '');
  }

  function handleFileUpload(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    uploadFileName.value = file.name;
    const size = file.size / (1024 * 1024);
    if (size > 300) {
      alert("O arquivo deve ter no máximo 300mb");
      return;
    }
    isUploading.value = true;
    transmissionService.uploadFile(file).then(function (res: AxiosResponse) {
      const { fileUrl } = res.data;
      uploadUrl.value = fileUrl;
    }).catch((error) => {
      console.log(error);
    }).finally(() => {
      isUploading.value = false;
    });
  }
  function handleCsv(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    console.time('csv');
    if (file) {
      const reader = new FileReader();
      reader.onload = function (e) {
        console.timeEnd('file');
        const csv = e.target?.result;
        if (csv) {
          Papa.parse(csv as never, {
            header: true,
            delimiter: ';',
            complete: function (results) {
              const rows = results.data;
              processMessages(rows);
            }
          });
        }
      };
      reader.readAsText(file);
    }
  }

  function processMessages(rows: any[]) {
    dests.value = rows.map(row => {
      let personalizedMessage = body.value;

      Object.keys(row).forEach(header => {
        const placeholder = `{{${header.trim().toLowerCase()}}}`;

        if (personalizedMessage.includes(placeholder)) {
          personalizedMessage = personalizedMessage.split(placeholder).join(row[header]);
        }
      });
      const number = row.Numero || row.numero || row.NUMERO; 
      const name = row.Nome || row.nome || row.NOME; 

      return {
        number: number, 
        name: name,
        message: personalizedMessage
      };
    });
  }

  function save() {
    const data = {
      name: name.value,
      dests: dests.value,
      body: body.value,
      fileUrl: attachmentType.value === 'file' ? uploadUrl.value : '',
      fileName: uploadFileName.value,
      videoUrl: attachmentType.value === 'link' ? uploadUrl.value : '',
      phoneNumber: selectedContact.value
    };

    isLoading.value = true;

    transmissionService.create(data).then((res) => {
      isLoading.value = false;
      router.replace({name: 'transmission', params: {id: res.data.id}}).then(() => {
        window.location.reload()
      });
    })
  }

  function getTransmission() {
    if (id || cloneId) {
      isLoading.value = true;
      transmissionService.getById(id || cloneId).then(response => {
        const data = response.data;
        body.value = data.body;
        name.value = data.name;
        uploadUrl.value = data.file_url;
        if (cloneId && !!data.file_url) {
          const aux = data.file_url.split('/');
          uploadFileName.value = aux[aux.length - 1];
        }
        dests.value = data.messages.map((dest: any) => {
          return {
            number: dest.contact.number,
            name: dest.contact.name,
            messageStatus: cloneId ? undefined : parseInt(dest.wpp_message_status)
          }
        });

        attachmentType.value = isVideoUrl(data.file_url) ? 'link' : 'file';
        if (id && !cloneId) {
          pageTitle.value = `Detalhes da Transmissão ${data.name}`;
        } else if (cloneId) {
          pageTitle.value = 'Clonar Transmissão';
        } else {
          pageTitle.value = 'Criar Transmissão';
        }
        isLoading.value = false;
      }).catch(() => {
        isLoading.value = false;
      });
    }
  }

  function isVideoUrl(url: string): boolean {
    const videoDomains = [
      'youtube.com', 'youtu.be', 'vimeo.com', 'dailymotion.com', 'twitch.tv',
      'streamable.com', 'facebook.com', 'twitter.com', 'instagram.com',
      'drive.google.com', 'dropbox.com', 'wistia.com', 'video.google.com',
      'video.yahoo.com', 'rutube.ru', 'metacafe.com', 'veoh.com', 'myspace.com',
      'vid.me', 'vine.co', 'periscope.tv', 'mixer.com', 'youku.com', 'bilibili.com',
      'tudou.com', 'vk.com', 'ok.ru'
    ];
    return videoDomains.some(domain => url.includes(domain));
  }


  onMounted(() => {
    getTransmission()
  });

  const contactsForSelect = ref<Contact[]>([]);
  const selectedContact = ref<string>('');

  const getPhoneList = async () => {
    try {
      const response = await transmissionService.getPhoneList();
      contactsForSelect.value = response.data as Contact[];
    } catch (error) {
      console.error('Erro ao obter lista de contatos:', error);
    }
  };

  onMounted(() => {
    getPhoneList();
  });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(id) && isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(pageTitle.value), 1)
        ]),
        (!_unref(id))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedContact).value = $event)),
                class: "form-control"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contactsForSelect.value, (contact) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: contact.phone_number,
                    value: contact.phone_number
                  }, _toDisplayString(contact.name) + " - " + _toDisplayString(contact.phone_number), 9, _hoisted_9))
                }), 128))
              ], 512), [
                [_vModelSelect, selectedContact.value]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((name).value = $event)),
            type: "text",
            class: "form-control",
            placeholder: "Insira o nome da transmissão",
            disabled: !!_unref(id)
          }, null, 8, _hoisted_12), [
            [_vModelText, name.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _withDirectives(_createElementVNode("textarea", {
            disabled: !!_unref(id),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((body).value = $event)),
            class: "form-control",
            rows: "3",
            placeholder: "Digite a mensagem (ex: Olá {{nome}}, seu cliente {{nome_cliente}} comprou o {{produto}}"
          }, null, 8, _hoisted_15), [
            [_vModelText, body.value]
          ])
        ]),
        (!_unref(id) || _unref(cloneId))
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "fileOption",
                  value: "file",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((attachmentType).value = $event))
                }, null, 512), [
                  [_vModelRadio, attachmentType.value]
                ]),
                _hoisted_18
              ]),
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "linkOption",
                  value: "link",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((attachmentType).value = $event))
                }, null, 512), [
                  [_vModelRadio, attachmentType.value]
                ]),
                _hoisted_20
              ]),
              (attachmentType.value === 'file')
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("input", {
                      type: "file",
                      class: "form-control file",
                      id: "arquivo",
                      ref_key: "attach",
                      ref: attach,
                      onChange: handleFileUpload
                    }, null, 544)
                  ]))
                : (attachmentType.value === 'link')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _hoisted_24,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "videoUrl",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((uploadUrl).value = $event)),
                        placeholder: "Insira o link do vídeo"
                      }, null, 512), [
                        [_vModelText, uploadUrl.value]
                      ])
                    ]))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_25, [
          (isUploading.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_26))
            : _createCommentVNode("", true),
          (uploadUrl.value !== '' && attachmentType.value === 'file')
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                target: "_blank",
                class: "mt-2",
                href: uploadUrl.value
              }, "Arquivo", 8, _hoisted_27))
            : _createCommentVNode("", true),
          (uploadUrl.value && !_unref(id) && attachmentType.value === 'file')
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "btn btn-danger btn-sm ml-1 mt-2",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (uploadUrl.value = ''))
              }, "X"))
            : _createCommentVNode("", true)
        ]),
        (!_unref(id))
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _withDirectives(_createElementVNode("input", {
                ref_key: "contactInput",
                ref: contactInput,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((maskedValue).value = $event)),
                "data-maska": "(##) #####-####",
                type: "text",
                class: "form-control",
                onKeydown: _withKeys(addContact, ["enter"])
              }, null, 544), [
                [_vModelText, maskedValue.value],
                [_unref(vMaska), contactValue]
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("button", {
                  class: "btn btn-info",
                  type: "button",
                  onClick: addContact,
                  disabled: contactValue.unmasked?.length <= 9
                }, "Adicionar", 8, _hoisted_30)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("button", {
                  class: "btn btn-success",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (uploadExcel.value?.click()))
                }, "Importar CSV"),
                _createElementVNode("input", {
                  type: "file",
                  id: "upload",
                  style: {"display":"none"},
                  ref_key: "uploadExcel",
                  ref: uploadExcel,
                  onChange: handleCsv
                }, null, 544)
              ])
            ]))
          : _createCommentVNode("", true),
        (!_unref(id))
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
          : _createCommentVNode("", true),
        (!!dests.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              (!_unref(id))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (dests.value = []), ["prevent"]))
                  }, "Limpar"))
                : _createCommentVNode("", true),
              _createElementVNode("ul", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dests.value, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.number,
                    class: _normalizeClass(["list-group-item d-flex justify-content-between align-items-center wpp-font-color", {'bg-danger': item.messageStatus === _unref(MessageStatusEnum).FAIL}])
                  }, [
                    _createTextVNode(_toDisplayString(item.name !== item.number ? item.number + ' - ' + item.name : item.number) + " ", 1),
                    (item.messageStatus !== undefined)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["badge badge-pill", item.messageStatus === _unref(MessageStatusEnum).READ ? 'read-message' : 'unread-message'])
                        }, [
                          _createVNode(_unref(FontAwesomeIcon), {
                            icon: getIconByStatus(item.messageStatus ?? 0)
                          }, null, 8, ["icon"])
                        ], 2))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: "#",
                          onClick: _withModifiers(($event: any) => (dests.value.splice(dests.value.indexOf(item), 1)), ["prevent"])
                        }, [
                          _createVNode(_unref(FontAwesomeIcon), {
                            class: "text-danger",
                            icon: _unref(faBan)
                          }, null, 8, ["icon"])
                        ], 8, _hoisted_37))
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_router_link, {
                class: "btn btn-primary mr-2",
                to: {name: 'listTransmissions'}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Voltar")
                ]),
                _: 1
              })
            ]),
            (!_unref(id))
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  (!isLoading.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-info",
                        onClick: save,
                        disabled: dests.value.length === 0 || body.value.length === 0 || isLoading.value || !selectedContact.value
                      }, " Salvar ", 8, _hoisted_42))
                    : (_openBlock(), _createElementBlock("button", _hoisted_43, _hoisted_45))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  (!isLoading.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-info",
                        onClick: getTransmission,
                        disabled: isLoading.value
                      }, " Atualizar ", 8, _hoisted_47))
                    : (_openBlock(), _createElementBlock("button", _hoisted_48, _hoisted_50))
                ]))
          ])
        ])
      ]))
}
}

})